<template>
  <!-- First/Last Goal -->
  <div class="template" v-if="newAllBetEvent.od[plytyp]">
    <template v-for="btype in btypes" v-if="newAllBetEvent.od[plytyp][btype]">
      <div data-template="template0" class="wrap-template template0">
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">
                {{ sportAllBetLang['ALL_BET.SUBHEADER_FLG'] }}
              </span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <div class="handicap">
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:85%;">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap">
                            {{ sportAllBetLang['ALL_BET.LBL_HFG'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'hf'" :plyType="plytyp" :betType="btype" ref="teamhf" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:85%;">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap">
                            {{ sportAllBetLang['ALL_BET.LBL_AFG'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'af'" :plyType="plytyp" :betType="btype" ref="teamaf" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:85%;">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap">
                            {{ sportAllBetLang['ALL_BET.LBL_HLG'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'hl'" :plyType="plytyp" :betType="btype" ref="teamhl" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:85%;">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap">
                            {{ sportAllBetLang['ALL_BET.LBL_ALG'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'al'" :plyType="plytyp" :betType="btype" ref="teamal" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:85%;">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap">
                            {{ sportAllBetLang['ALL_BET.LBL_NG'] }}
                          </span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <cstgftht :event="newAllBetEvent" :score="'ng'" :plyType="plytyp" :betType="btype" ref="teamng" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-undefined no_border_bottom"></div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().flgBetType, allBetMixin.data().rflgBetType],
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
        if(this.mode=='ab'){
            this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
    },
    foldopenFirstEvent() {
        if(this.mode!='ab'){
            this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
    }
  },
  methods: {
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, flgBetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, flgBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, flgBetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, flgBetType, this.isSpecial)
    },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-flg.vue